import React, { Fragment, useState } from "react";
import { Button, Tabs } from "react-bootstrap";
// import usePropuestaFetch from "../hooks/use_propuesta_fetch";
import useLogin from "../providers/use_login";
import WikiNavBar from "../components/navbar";
import Footer from "../components/footer";
import Login from "../components/login";
import Loading from "../components/loading";
import AdminModal from "../components/admin-modal";
import TablaPropuestas from "../components/tabla-propuestas";
import getWebTab from "../components/web-tab";
import getMarkdownTab from "../components/MarkdownTab";
import MdParser from "../utils/parser";
import usePropuestaFetch from "../hooks/use_propuesta_fetch";

const RevisionPage = ({ id }) => {
  const { user } = useLogin();
  const [show, setShow] = useState(false);
  const [isBorrar, setIsBorrar] = useState(false);
  const { propuesta, isBusy } = usePropuestaFetch(id);

  // if (!id) return <AdminNavigationError />;
  if (!user)
    return (
      <>
        <WikiNavBar />
        <div style={{ marginTop: 55 }} />
        <Login />
      </>
    );
  if (isBusy)
    return (
      <>
        <WikiNavBar />
        <Loading />
      </>
    );

  propuesta.html = MdParser.parse(propuesta.contenido || "");

  return (
    <Fragment>
      <WikiNavBar />
      <div className="container">
        <div style={{ height: 20 }} />
        <h2>Revisión de Propuesta</h2>
        <TablaPropuestas propuesta={propuesta} />
        <br />
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Tabs defaultActiveKey="web" id="uncontrolled-tab-example">
            {getWebTab(propuesta)}
            {getMarkdownTab(propuesta)}
          </Tabs>
        </div>
        <br />
        <h4 style={{ textAlign: "center" }}>¿Qué hacer con esta propuesta?</h4>
        <div style={{ textAlign: "center", marginTop: 32 }}>
          <Button
            variant="danger"
            onClick={() => {
              setIsBorrar(true);
              setShow(true);
            }}
          >
            <i className="fas fa-trash"></i> Rechazar
          </Button>{" "}
          <Button
            variant="success"
            onClick={() => {
              setIsBorrar(false);
              setShow(true);
            }}
          >
            <i className="fas fa-check"></i> Aceptar y Publicar
          </Button>
          <br />
          <br />
        </div>
        <AdminModal
          propuesta={propuesta}
          setShow={setShow}
          isBorrar={isBorrar}
          show={show}
          onHide={() => setShow(false)}
        />
        <br />
        <br />
      </div>
      <Footer />
    </Fragment>
  );
};

export default RevisionPage;
